export const DEFAULT_TRANSLATION_DESKTOP = 0;
export const DEFAULT_TRANSLATION_MOBILE = 0;

export const ITEM_DESKTOP_WIDTH = 108;
export const ITEM_DESKTOP_MARGIN = 12;
export const ITEM_MOBILE_WIDTH = 100;
export const ITEM_MOBILE_MARGIN = 8;
export const ITEM_MOBILE_HEIGHT = 70;
export const ITEM_DESKTOP_HEIGHT = 76;

export const ITEM_DESKTOP_FULL_WIDTH = ITEM_DESKTOP_WIDTH + ITEM_DESKTOP_MARGIN;
export const ITEM_MOBILE_FULL_WIDTH = ITEM_MOBILE_WIDTH + ITEM_MOBILE_MARGIN;

export const AVAILABLE_CATEGORY_IMAGES = [
  'ilustracion-digital',
  'marketing-digital',
  'liderazgo',
  'soft-skills',
  'diseno-grafico',
  'dibujo-y-pintura',
  'transformacion-digital-e-innovacion',
  'data-y-analitica',
  'ventas',
  'diseno-de-productos',
  'fotografia',
  'video',
  'productividad-y-software',
  'emprendimiento-y-negocios',
  'estilo-de-vida',
  'manualidades-y-cocina',
  'desarrollo-web-y-tecnologia',
  'modelado-y-animacion-3d',
  'animacion-2d',
  'administracion-y-finanzas',
  'servicio-y-atencion-al-cliente',
  'arquitectura-digital',
];
